import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

let staffCache = null;
const loadStaff = () => (staffCache ||= api.get("/staff").then((r) => r.data || []).catch(() => { staffCache = null; return []; }));

// ?staff=<id> kept in the page address so filtered views can be bookmarked
export function useStaffParam() {
  const [params, setParams] = useSearchParams();
  const value = params.get("staff") || "";
  const set = (v) => { const p = new URLSearchParams(params); if (v) p.set("staff", v); else p.delete("staff"); setParams(p, { replace: true }); };
  return [value, set];
}

export function StaffFilterSelect({ value, onChange, myLabel = "Mine", testid }) {
  const { user } = useAuth();
  const [staff, setStaff] = useState([]);
  useEffect(() => { loadStaff().then(setStaff); }, []);
  return (
    <select data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)}
      className={`px-3 py-2 rounded-xl border text-sm ${value ? "border-primary/50 text-primary font-semibold bg-primary/5" : "border-slate-200 bg-white"}`}>
      <option value="">All staff</option>
      {user?.id && <option value={user.id}>{myLabel}</option>}
      {staff.filter((x) => x.id !== user?.id).map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
    </select>
  );
}
